import { Link } from "@remix-run/react";
import { clsx } from "clsx";

type ButtonProps = {
  /** `solid` for the primary action, `outline` for the one sitting next to it. */
  variant?: "solid" | "outline";
  /** `lg` is for hero and section-level calls to action. */
  size?: "sm" | "lg";
} & (
  | React.ComponentPropsWithoutRef<typeof Link>
  | (React.ComponentPropsWithoutRef<"button"> & { to?: undefined })
);

export function Button({
  variant = "solid",
  size = "sm",
  className,
  children,
  ...props
}: ButtonProps) {
  className = clsx(
    className,
    "inline-flex items-center justify-center rounded-full font-semibold transition",
    size === "lg" ? "px-6 py-3 text-base" : "px-4 py-2 text-sm",
    variant === "solid"
      ? "bg-ink-50 text-ink-950 hover:bg-white"
      : "text-ink-50 ring-1 ring-inset ring-ink-600 hover:bg-ink-50/5 hover:ring-ink-500",
  );

  if (typeof props.to === "undefined") {
    return (
      <button className={className} {...props}>
        {children}
      </button>
    );
  }

  // `Link` renders a plain anchor for absolute destinations such as `mailto:`.
  return (
    <Link className={className} {...props}>
      {children}
    </Link>
  );
}
